import React, { useState } from 'react';
import { sendFormData } from '../utils/sendForm';
import { useForm } from 'react-hook-form';
import { X, MapPin, Phone, User, Mail, MessageSquare } from 'lucide-react';
import Notification from './Notification';
import './ReservationModal.css';

const ReservationModal = ({ isOpen, onClose }) => {
  const [notification, setNotification] = useState({ show: false, type: 'success', title: '', message: '' });
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = async (data) => {
    try {
      await sendFormData({ type: 'reservation', ...data }, 'reservation');
      reset();
      setNotification({
        show: true,
        type: 'success',
        title: 'Notification enregistrée ! ✨',
        message: 'Vous serez averti dès que notre service brunch sera disponible. Merci pour votre intérêt ! À très bientôt chez Pinky Cloud ! 💕'
      });
      // Le popup reste affiché plus longtemps (15 secondes)
      setTimeout(() => { 
        setNotification({ show: false, type: 'success', title: '', message: '' });
        onClose(); 
      }, 15000);
    } catch (e) {
      console.error('Reservation send error', e);
      setNotification({
        show: true,
        type: 'error',
        title: 'Erreur lors de l\'envoi',
        message: 'Une erreur est survenue. Veuillez réessayer plus tard.'
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header avec bordure colorée */}
        <div className="modal-header">
          <h2>Réserver votre table</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)} className="reservation-form">
            <input type="text" name="website" style={{display:'none'}} aria-hidden="true" tabIndex="-1" />
            
            {/* Section Réservation */}
            <div className="form-section">
              <h3 className="form-section-title">Être notifié du lancement brunch</h3>
              <p className="form-description">
                Laissez-nous vos coordonnées et nous vous préviendrons dès que notre service brunch sera disponible !
              </p>
            </div>

            {/* Info Restaurant */}
            <div className="restaurant-info-compact">
              <div className="info-item">
                <MapPin size={18} />
                <span>49 Rue du Chemin Vert, 75011 Paris</span>
              </div>
              <div className="info-item">
                <Phone size={18} />
                <span>+33 7 59 51 13 19</span>
              </div>
            </div>

            {/* Section Contact */}
            <div className="form-section">
              <h3 className="form-section-title">
                Vos coordonnées
              </h3>
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">
                    <User size={16} />
                    Nom complet
                  </label>
                  <input
                    type="text"
                    className="form-input"
                    {...register('name', { required: 'Le nom est requis' })}
                    placeholder="Prénom et nom"
                  />
                  {errors.name && <span className="error">{errors.name.message}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label">
                    <Mail size={16} />
                    Adresse e-mail
                  </label>
                  <input
                    type="email"
                    className="form-input"
                    {...register('email', { 
                      required: 'L\'email est requis',
                      pattern: {
                        value: /^\S+@\S+$/i,
                        message: 'Format d\'email invalide'
                      }
                    })}
                    placeholder="votre@email.com"
                  />
                  {errors.email && <span className="error">{errors.email.message}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label">
                    <Phone size={16} />
                    Téléphone
                  </label>
                  <input
                    type="tel"
                    className="form-input"
                    {...register('phone', { required: 'Le téléphone est requis' })}
                    placeholder="+33 6 12 34 56 78"
                  />
                  {errors.phone && <span className="error">{errors.phone.message}</span>}
                </div>
              </div>
            </div>

            {/* Section Préférences */}
            <div className="form-section">
              <h3 className="form-section-title">
                Préférences & demandes spéciales
              </h3>
              <div className="form-group">
                <label className="form-label">
                  <MessageSquare size={16} />
                  Message (optionnel)
                </label>
                <textarea
                  className="form-textarea"
                  {...register('special')}
                  placeholder="Allergies alimentaires, préférences de table, occasion spéciale, demandes particulières..."
                  rows="4"
                />
              </div>
            </div>

            <button type="submit" className="submit-button">
              M'inscrire aux notifications
            </button>
          </form>
        </div>
      </div>
      
      <Notification
        show={notification.show}
        type={notification.type}
        title={notification.title}
        message={notification.message}
        onClose={() => setNotification({ show: false, type: 'success', title: '', message: '' })}
      />
    </div>
  );
};

export default ReservationModal; 